import * as Yup from 'yup';

export const forgotPasswordValidator = Yup.object().shape({
    email: Yup.string().required('Campo obrigatório').email('Endereço de email inválido'),
});
